import * as types from './actionTypes'

export const toggleSidebar = (payload) => ({
  type: types.TOGGLE_SIDEBAR,
  payload
})
